import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Facebook, Copy, Send, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const SITE = 'https://bethtokens.com/pas';
const DEFAULT_CAPTION = `Wake up.

The Matrix has you... but not anymore.

BETHCOIN Exchange Market. Open your BETH wallet, mint digital crypto checks secured by SHA-256 blockchain signatures, and take control of your credit.

You are the banker now.

Watch the trailer: ${SITE}

#BETHCOIN #YouAreTheBankerNow #Crypto #Blockchain #DigitalChecks`;

export const FacebookSharePanel = ({ token }) => {
  const [caption, setCaption] = useState(DEFAULT_CAPTION);
  const [status, setStatus] = useState(null);
  const [mode, setMode] = useState('video');
  const [posting, setPosting] = useState(false);
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  const loadStatus = () => axios.get(`${API}/api/facebook/status`, auth)
    .then(r => setStatus(r.data)).catch(() => setStatus({ configured: false }));
  useEffect(() => { loadStatus(); }, [token]);

  const shareWindow = async () => {
    try {
      await navigator.clipboard.writeText(caption);
      toast.success('Caption copied. Paste it into Facebook and press Post.');
    } catch (e) {
      toast.error('Could not copy caption. Select and copy it manually.');
    }
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(SITE)}`, '_blank', 'width=640,height=560');
  };

  const autoPost = async () => {
    setPosting(true);
    try {
      await axios.post(`${API}/api/facebook/post-trailer`, { caption, mode }, auth);
      toast.success('Posted to your Facebook Page');
      loadStatus();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Facebook post failed');
    }
    setPosting(false);
  };

  return (
    <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 mb-6" data-testid="facebook-share-panel">
      <div className="flex items-center gap-3 mb-4">
        <Facebook className="w-6 h-6 text-blue-400" />
        <h2 className="text-xl font-bold text-white">Share Trailer on Facebook</h2>
      </div>
      <label className="text-sm text-slate-400 block mb-2">Caption</label>
      <textarea value={caption} onChange={(e) => setCaption(e.target.value)} maxLength={5000}
        className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded-lg text-white h-44 text-sm"
        data-testid="fb-caption" />
      <div className="grid md:grid-cols-2 gap-4 mt-4">
        <div className="bg-slate-900/50 rounded-lg p-4 border border-slate-700">
          <p className="text-white text-sm font-medium mb-1">Share window</p>
          <p className="text-xs text-slate-500 mb-3">Copies the caption and opens Facebook. Works for your profile or any Page.</p>
          <button onClick={shareWindow} data-testid="fb-share-window-btn"
            className="w-full py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-lg text-sm flex items-center justify-center gap-2 transition-colors">
            <Copy className="w-4 h-4" /> Copy caption & open Facebook
          </button>
        </div>
        <div className="bg-slate-900/50 rounded-lg p-4 border border-slate-700">
          <p className="text-white text-sm font-medium mb-1">Post automatically to my Page</p>
          {status?.configured ? (
            <>
              <select value={mode} onChange={(e) => setMode(e.target.value)} data-testid="fb-post-mode"
                className="w-full mb-2 px-3 py-2 bg-slate-700 border border-slate-600 rounded-lg text-white text-sm">
                <option value="video">Upload the trailer video</option>
                <option value="link">Post a link to bethtokens.com</option>
              </select>
              <button onClick={autoPost} disabled={posting || !caption.trim()} data-testid="fb-auto-post-btn"
                className="w-full py-2 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white rounded-lg text-sm flex items-center justify-center gap-2 transition-colors">
                {posting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Post now
              </button>
              {status?.last_post && (
                <p className="text-xs text-slate-500 mt-2" data-testid="fb-last-post">
                  Last post: {new Date(status.last_post.created_at).toLocaleString()} ({status.last_post.kind})
                </p>
              )}
            </>
          ) : (
            <p className="text-xs text-amber-400" data-testid="fb-not-connected">
              Your Facebook Page isn't connected yet. Add your Page ID and Page access token to turn this on.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
